export const errorRateChart = (data = []) => {
  const timestamps = data.map(d => d.timestamp);

  const categories = [
    { key: 'http4xx', label: '4xx Errors', color: '#faad14' },
    { key: 'http5xx', label: '5xx Errors', color: '#f5222d' },
    { key: 'timeout', label: 'Timeouts', color: '#722ed1' },
    { key: 'connectionError', label: 'Connection Errors', color: '#eb2f96' }
  ];

  const series = categories.map(cat => ({
    name: cat.label,
    type: 'line',
    stack: 'errors',
    areaStyle: { opacity: 0.4 },
    smooth: true,
    showSymbol: false,
    data: data.map(d => d[cat.key] ?? 0),
    itemStyle: { color: cat.color },
    lineStyle: { width: 1.5 }
  }));

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'cross' }
    },
    legend: {
      data: categories.map(c => c.label),
      bottom: 0
    },
    grid: {
      left: '3%',
      right: '3%',
      top: '10%',
      bottom: '12%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: timestamps,
      boundaryGap: false,
      axisLabel: { fontSize: 10 }
    },
    yAxis: {
      type: 'value',
      name: 'Errors',
      axisLabel: { fontSize: 10 }
    },
    series
  };
};
